export default {"src":"/_next/static/media/clock.36912811.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};